// One way to show an amount of money, in the company's own currency and number style. The company
// settings reach the browser as `me.company` ({ currency, numberFormat }); the defaults below are
// the same ones the server uses until a company chooses otherwise.
export const DEFAULT_CURRENCY = "INR";
const DEFAULT_NUMBER_FORMAT = "en-IN";

// Just the currency sign for the company ("$", "₹"), for places that build their own compact amounts.
export function currencySymbol(company) {
  const currency = company?.currency || DEFAULT_CURRENCY;
  try {
    const parts = new Intl.NumberFormat(company?.numberFormat || DEFAULT_NUMBER_FORMAT, { style: "currency", currency }).formatToParts(0);
    return parts.find((part) => part.type === "currency")?.value || currency;
  } catch {
    return currency;
  }
}

export function formatMoney(value, company) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "-";
  const currency = company?.currency || DEFAULT_CURRENCY;
  try {
    return new Intl.NumberFormat(company?.numberFormat || DEFAULT_NUMBER_FORMAT, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    // An unknown currency code or locale must not blank a pay screen.
    return `${currency} ${amount}`;
  }
}
